// src/components/admin/AdminChangePassword.js
import React, { useState } from 'react';
import axios from 'axios';
import { FaLock, FaSave, FaEye, FaEyeSlash } from 'react-icons/fa'; // Removed FaKey

const API_BASE = process.env.REACT_APP_API_URL;

const AdminChangePassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(''); // Clear previous messages

    if (newPassword !== confirmNewPassword) {
      setMessage('❌ New passwords do not match.');
      return;
    }

    if (newPassword.length < 6) {
      setMessage('❌ New password must be at least 6 characters long.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setMessage('❌ Authentication error: Please log in.');
        return;
      }

      await axios.put(`${API_BASE}/api/auth/admin/change-password`, {
        oldPassword,
        newPassword
      }, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      setMessage('✅ Password changed successfully!');
      setOldPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
    } catch (err) {
      console.error('Password change failed:', err.response?.data || err.message, err.response?.status);
      let errorMessage = '❌ Failed to change password. Please try again.';
      if (err.response && err.response.data && err.response.data.message) {
        errorMessage = `❌ ${err.response.data.message}`;
      } else if (err.response?.status === 401 || err.response?.status === 403) {
        errorMessage = '❌ Access denied: Invalid credentials or not authorized as admin.';
      }
      setMessage(errorMessage);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-gray-800 flex items-center">
        <FaLock className="mr-2 text-cyan-600" /> Change Admin Password
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="relative">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="oldPassword">
            Old Password
          </label>
          <input
            type={showOldPassword ? 'text' : 'password'}
            id="oldPassword"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-cyan-500 pr-10"
            required
          />
          <button
            type="button"
            onClick={() => setShowOldPassword(!showOldPassword)}
            className="absolute inset-y-0 right-0 pr-3 flex items-center pt-6 text-gray-500 hover:text-gray-700 focus:outline-none"
            aria-label={showOldPassword ? 'Hide old password' : 'Show old password'}
          >
            {showOldPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <div className="relative">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="newPassword">
            New Password
          </label>
          <input
            type={showNewPassword ? 'text' : 'password'}
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-cyan-500 pr-10"
            required
          />
          <button
            type="button"
            onClick={() => setShowNewPassword(!showNewPassword)}
            className="absolute inset-y-0 right-0 pr-3 flex items-center pt-6 text-gray-500 hover:text-gray-700 focus:outline-none"
            aria-label={showNewPassword ? 'Hide new password' : 'Show new password'}
          >
            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <div className="relative">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="confirmNewPassword">
            Confirm New Password
          </label>
          <input
            type={showConfirmNewPassword ? 'text' : 'password'}
            id="confirmNewPassword"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-cyan-500 pr-10"
            required
          />
          <button
            type="button"
            onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
            className="absolute inset-y-0 right-0 pr-3 flex items-center pt-6 text-gray-500 hover:text-gray-700 focus:outline-none"
            aria-label={showConfirmNewPassword ? 'Hide confirm new password' : 'Show confirm new password'}
          >
            {showConfirmNewPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <button
          type="submit"
          className="w-full px-5 py-2 bg-cyan-600 text-white rounded-md hover:bg-cyan-700 transition flex items-center justify-center"
        >
          <FaSave className="inline-block mr-2" /> Change Password
        </button>
      </form>

      {message && (
        <p className={`mt-4 text-center ${message.startsWith('✅') ? 'text-green-600' : 'text-red-600'}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default AdminChangePassword;